import React, { Component } from 'react';

import './Howitworks.css';
import Illubacker from '../Icons/Illubacker.svg';
import Addproject from '../Icons/addproject.png';
import Makeitpigger from '../Icons/makeitpigger.png';
import Sheeptheproject from '../Icons/sheeptheproject.png';

class Howitworks extends Component {

	setCurrentRoute(){
		this.props.actions.setCurrentRoute('How it works');
	}

	componentDidMount() {
	    this.setCurrentRoute();
	}

  	render() {
	    return (
	      <div>
	      	<div className="container">
	      		<div className="faq-container">
					<div className="faq-bloc">
						<div className="illustration">
							<img src={Illubacker} alt="Logo Backon" />
						</div>
						<div className="text">
							<div className="title">What is the “Cagnotte”?</div>
							<div className="desc">
								“Cagnotte” means piggy bank or money pot in French. Every iAdvize employee (interns included) receives €150 every year. So how can you spend this amount and what for? Well anything really! As long as it’s in the interest of your colleagues or clients and the company globally. 
								<br/><br/>
								You could use the “Cagnotte”  to buy a product or to organize an event for iAdvize. 
								If it is an object, we need to know where we can find it in any office. If it is an event, it should involve at least one team. 
								<br/><br/>
								Here are some examples of projects that were funded over the past years: a karaoke evening open to all, a royal welcome for one of our most faithful clients, fund raising events & races for charity, customised treats for a special client, a board game to onboard newbies, a wellness week… And the great thing is that, thanks to Back’on, you can create team projects and “crowdfund” amongst your colleagues to create “pigger” and better projects!
								<br/><br/>
								Yet, some other kind of projects cannot be paid for by a “Cagnotte”, here is a non exhaustive list of examples:
								<br/>- gift to an employee, it is a benefits in kind (BIK)
								<br/>- Organize a send-off party
								<br/><br/>
								To clarify this point : If we use the “Cagnotte” to give a gift to an employee (ticket for a concert, smartbox,…) it is a benefits in kind. The sum will be liable to tax or social security contributions and will appear on their pay slip. That means the employees who gets the gift will pay a tax on this benefits in kind. For example, if your gift cost 50€, the employee will have to pay €25 as BIK.
								<br/><br/>
								There is no manager validation process. However, iAdvize reserves the right to refuse projects if they don’t follow the rules previously mentioned.
								<br/><br/>
								For any question, <a href="https://mail.google.com/mail/u/0/?compose=0&view=cm&fs=1&to=ismahan.grosboismoreau@iadvize.com&su=Question%20about%20Backon&tf=1" target="_blank" rel="noopener noreferrer">contact Ismahan</a>.
							</div>
						</div>
					</div>
					<div className="faq-bloc">
						<div className="content">
							<div className="title">How does Back’on work?</div>
							<div className="desc">
								All Cagnotte projects must be created within Back’on: whether it’s an individual or team project, open or closed.
								<br/>It needs to be registered here because this is how we will keep track of how much money you have left to donate. 
								<div className="blocs">
									<div className="bloc">
										<div className="title">1. Add a project</div>
										<div className="description">
											It can be open to all (maximum crowdfunding potential) or closed (an individual project or a project endorsed by a specific group).
										</div>
										<div className="capture">
											<img src={Addproject} alt="Add a project" />
										</div>
									</div>
									<div className="bloc">
										<div className="title">2. Make it pigger</div>
										<div className="description">
											Even if you are the only participant, you must add an amount to your project.
										</div>
										<br/>
										<div className="capture">
											<img src={Makeitpigger} alt="Add a project" />
										</div>
									</div>
									<div className="bloc">
										<div className="title">3. Sheep the project</div>
										<div className="description">
											This step allows you to obtain financing for your project.
										</div>
										<br/>
										<div className="capture">
											<img src={Sheeptheproject} alt="Add a project" />
										</div>
									</div>
								</div>
								<strong>IMPORTANT</strong>
								<br/>- As long as the project is not sheeped, your backers can leave the project.
								<br/>- A project must be sheeped in the current year.
								<br/>Example: If you created your project in 2018, you have to sheep it before January 1, 2019 in order for the 2018 cagnotte to be decreased.
								<div className="blocs">
									<div className="bloc solo">
										<div className="title">4. Choose your financing</div>
										<div className="subBlocs">
											<div className="subBloc">
												<strong>Your project costs <span className="pink">less than 100 euros.</span></strong>
												<br/><br/>
												The responsible
												<br/>- raises the cash
												<br/>- makes the purchase
												<br/>- requests a refund via Cleemy 
												<br/><br/>
												<strong>IMPORTANT</strong>
												<br/>- the declaration must only be made by the responsible
												<br/>- he must declare the total amount 
											</div>
											<div className="subBloc">
												<strong>Your project costs <span className="pink">more than 100 euros.</span></strong>
												<br/><br/>
												The responsible can still make the purchase himself and request a refund.
												<br/><br/>
												<strong>OR</strong>
												<br/><br/>
												iAdvize can make the purchase.
												<br/>The payment will be made by iAdvize <strong>45 days</strong> after the invoice is received.
											</div>
										</div>
									</div>
								</div>
								Any questions? <a href="https://mail.google.com/mail/u/0/?compose=0&view=cm&fs=1&to=ismahan.grosboismoreau@iadvize.com&su=Question%20about%20Backon&tf=1" target="_blank" rel="noopener noreferrer">Contact Ismahan</a>.
							</div>
						</div>
					</div>
				</div>
			</div>
	      </div>
	    );
  	}
}

export default Howitworks;



// WEBPACK FOOTER //
// ./src/components/Howitworks/Howitworks.js